module.exports = __webpack_public_path__ + "static/media/treehacks-text.10ebab5b.png";